import { Component } from '@angular/core';
import {
  Event,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { ApiService } from './services/api/api.service';
import { LocalStorageService } from 'angular-web-storage';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'assistencia-financeira-desktop';

  constructor(
    private router: Router,
    private api: ApiService,
    private storage: LocalStorageService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.match(/^(\/login|\/cadastro)/gi) === null) {
          this._checkSession();
        }
      }
    });
  }

  private _checkSession() {
    const cpfByHash = this.storage.get('cpfByHash');
    const cpf = cpfByHash ? cpfByHash : this.storage.get('userData').CPF;
    const token = this.storage.get('Token');

    this.api
      .query(
        'auto-contratacao/cliente/cpf?cpf=' + cpf + '&token=' + token + '',
        {},
        'get'
      )
      ?.subscribe(
        (data: any) => {
          if (data?.Mensagem?.toLowerCase()?.includes('token inválido'))
            return this.api.logout();
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status == HttpStatusCode.Unauthorized) {
              return this.api.logout();
            }
            if (
              err?.error?.ErrorMessageFormat?.toLowerCase()?.includes(
                'token inválido'
              )
            ) {
              return this.api.logout();
            }
            if (
              err?.error?.Message?.toLowerCase()?.includes('token inválido')
            ) {
              return this.api.logout();
            }
          }
        }
      );
  }
}
